import React from 'react';
import {PopupInterface} from "../interfaces/PopupInterface";

interface Props {
    popupData: PopupInterface,
    setPopupData: (data: PopupInterface) => void
}

const Popup = (props: Props) => {

    const {popupData, setPopupData} = props

    if (!popupData.isActive) {
        return null
    }

    const closePopup = () => {
        setPopupData({
            isActive: false,
            message: '',
            title: ''
        })
    }

    return (
        <div className="c-popup">

            <div className="c-popup__content">

                <div className="c-popup__header">
                    <span className="c-popup__header__title">{popupData.title}</span>
                    <span className="c-popup__header__close" onClick={() => closePopup()}>X</span>
                </div>

                <div className=" c-popup__body">
                    <p>{popupData.message}</p>
                </div>

                <div className="c-popup__footer">
                    <button className="c-popup__submit" onClick={() => closePopup()}>
                        <span>Oke</span>
                    </button>
                </div>

            </div>

        </div>
    )
}

export default Popup;